import { SearchBox } from '@cko/primitives';
import React, { useState, useCallback, forwardRef, useImperativeHandle } from 'react';

export type AccountSelectorSearchRef = {
  resetSearch: () => void;
};

interface AccountSelectorSearchProps {
  onSubmitSearch: (value: string) => void;
  onResetSearch: () => void;
}

export const AccountSelectorSearch = forwardRef<
  AccountSelectorSearchRef | null | undefined,
  AccountSelectorSearchProps
>(({ onSubmitSearch, onResetSearch }: AccountSelectorSearchProps, ref) => {
  const [searchString, setSearchString] = useState<string | undefined>('');
  const resetSearch = useCallback(() => {
    setSearchString('');
    onResetSearch();
  }, [setSearchString, onResetSearch]);

  const submitSearch = useCallback(() => {
    if (searchString && searchString !== '') {
      onSubmitSearch(searchString);
    } else {
      onResetSearch();
    }
  }, [searchString, onSubmitSearch, onResetSearch]);

  useImperativeHandle(ref, () => ({
    resetSearch,
  }));

  return (
    <SearchBox
      data-analytics-id="account-selector-search"
      onSubmit={submitSearch}
      width="280px"
      aria-label="Search Clients and Entities"
      onSearch={submitSearch}
      onClear={resetSearch}
      onChange={setSearchString}
      placeholder="Search Clients and Entities"
      autoFocus
      value={searchString}
    />
  );
});
